import { Permission, Routes, Tabs } from 'src/utils/enums';

interface PermissionsInterface {
  [key: string]: {
    path: Routes;
    tab: Tabs;
  };
}

interface MappingsInterface {
  [key: string]: {
    navItem?: Routes;
    permission: Permission;
    tab: Tabs;
  };
}

export const permissionsArray: PermissionsInterface = {
  [Permission.SOLVE]: {
    path: Routes.SOLVE,
    tab: Tabs.SOLVE,
  },
  [Permission.MACRO_CONTROLS]: {
    path: Routes.MACRO_CONTROLS,
    tab: Tabs.MACRO_CONTROLS,
  },
  [Permission.WORKFLOW_BUILDER]: {
    path: Routes.WORKFLOW_BUILDER,
    tab: Tabs.WORKFLOW_BUILDER,
  },
  [Permission.FLAMETHROWER]: {
    path: Routes.ACTION_BUILDER,
    tab: Tabs.ACTION_BUILDER,
  },
  [Permission.ACTION_BUILDER]: {
    path: Routes.ACTION_BUILDER,
    tab: Tabs.ACTION_BUILDER,
  },
  [Permission.FLAMETHROWER_WORKFLOW_BUILDER_EDIT]: {
    path: Routes.WORKFLOW_BUILDER_EDIT,
    tab: Tabs.WORKFLOW_BUILDER_EDIT,
  },
  [Permission.LOOKER_ANALYTICS]: {
    path: Routes.LOOKER_ANALYTICS,
    tab: Tabs.LOOKER_ANALYTICS,
  },
  [Permission.DISCOVER]: {
    path: Routes.DISCOVER_INSIGHTS,
    tab: Tabs.DISCOVER,
  },
  [Permission.SOLVE_LITE]: {
    path: Routes.SOLVE_LITE,
    tab: Tabs.SOLVE_LITE,
  },
  [Permission.SOLVE_PREVIEW]: {
    path: Routes.SOLVE_PREVIEW,
    tab: Tabs.SOLVE_PREVIEW,
  },
  [Permission.ASSIST]: {
    path: Routes.ASSIST_NOTES,
    tab: Tabs.ASSIST_NOTES,
  },
  [Permission.PREDICT_INTENTS]: {
    path: Routes.PREDICT_INTENTS,
    tab: Tabs.SIMULATIONS,
  },
  [Permission.PREDICTIONS]: {
    path: Routes.TRIAGE_INSIGHTS,
    tab: Tabs.PREDICTIONS,
  },
  [Permission.SOLVE_INSIGHTS]: {
    path: Routes.SOLVE_INSIGHTS_MAIN,
    tab: Tabs.SOLVE_INSIGHT,
  },
  [Permission.SOLVE_INSIGHTS_VIEW]: {
    path: Routes.SOLVE_INSIGHTS_MAIN,
    tab: Tabs.SOLVE_INSIGHT,
  },
  [Permission.AGENT_INSIGHTS]: {
    path: Routes.AGENT_QA,
    tab: Tabs.AGENT_QA,
  },
  [Permission.AI_QA]: {
    path: Routes.AI_QA,
    tab: Tabs.AI_QA,
  },
  [Permission.LOG]: {
    path: Routes.LOG,
    tab: Tabs.LOG,
  },
  [Permission.ORCHESTRATOR]: {
    path: Routes.ORCHESTRATOR,
    tab: Tabs.ORCHESTRATOR,
  },
};

export const appSelectedMappings: MappingsInterface = {
  [Routes.DISCOVER_DASHBOARD]: {
    navItem: Routes.DISCOVER_DASHBOARD,
    permission: Permission.DISCOVER,
    tab: Tabs.DISCOVER_DASHBOARD,
  },
  [Routes.DISCOVER_AUTOMATION]: {
    navItem: Routes.DISCOVER_AUTOMATION,
    permission: Permission.DISCOVER,
    tab: Tabs.DISCOVER_AUTOMATION,
  },
  [Routes.DISCOVER_TOPIC_DETAIL]: {
    navItem: Routes.DISCOVER_TOPIC_DETAIL,
    permission: Permission.DISCOVER,
    tab: Tabs.DISCOVER,
  },
  [Routes.DISCOVER_TOPICS]: {
    navItem: Routes.DISCOVER_TOPICS,
    permission: Permission.DISCOVER,
    tab: Tabs.DISCOVER_TOPICS,
  },
  [Routes.ASSIST_NOTES]: {
    permission: Permission.ASSIST,
    tab: Tabs.ASSIST_NOTES,
  },
  [Routes.SOLVE]: {
    permission: Permission.SOLVE,
    tab: Tabs.SOLVE,
  },
  [Routes.MACRO_CONTROLS]: {
    permission: Permission.MACRO_CONTROLS,
    tab: Tabs.MACRO_CONTROLS,
  },
  [Routes.WORKFLOW_BUILDER]: {
    permission: Permission.FLAMETHROWER_WORKFLOW_BUILDER_EDIT,
    tab: Tabs.WORKFLOW_BUILDER,
  },
  [Routes.WORKFLOW_BUILDER_EDIT]: {
    permission: Permission.FLAMETHROWER_WORKFLOW_BUILDER_EDIT,
    tab: Tabs.WORKFLOW_BUILDER,
  },
  [Routes.ACTION_BUILDER]: {
    permission: Permission.ACTION_BUILDER,
    tab: Tabs.ACTION_BUILDER,
  },
  [Routes.ACTION_BUILDER_EDIT]: {
    permission: Permission.ACTION_BUILDER,
    tab: Tabs.ACTION_BUILDER,
  },
  [Routes.ACTION_BUILDER_EDIT_V2]: {
    permission: Permission.ACTION_BUILDER,
    tab: Tabs.ACTION_BUILDER,
  },
  [Routes.LOOKER_ANALYTICS]: {
    permission: Permission.LOOKER_ANALYTICS,
    tab: Tabs.LOOKER_ANALYTICS,
  },
  [Routes.SOLVE_LITE]: {
    permission: Permission.SOLVE_LITE,
    tab: Tabs.SOLVE_LITE,
  },
  [Routes.SOLVE_PREVIEW]: {
    permission: Permission.SOLVE_PREVIEW,
    tab: Tabs.SOLVE_PREVIEW,
  },
  [Routes.SOLVE_CONFIGURATION]: {
    permission: Permission.WORKFLOW_BUILDER,
    tab: Tabs.SOLVE_CONFIGURATION,
  },
  [Routes.SOLVE_API_CONFIGURATION]: {
    permission: Permission.SOLVE_API,
    tab: Tabs.SOLVE_API_CONFIGURATION,
  },
  [Routes.PREDICT_INTENTS]: {
    permission: Permission.PREDICT_INTENTS,
    tab: Tabs.SIMULATIONS,
  },
  [Routes.SOLVE_INSIGHTS_MAIN]: {
    navItem: Routes.SOLVE_INSIGHTS_MAIN,
    permission: Permission.SOLVE_INSIGHTS_VIEW,
    tab: Tabs.SOLVE_INSIGHT,
  },
  [Routes.AGENT_QA]: {
    navItem: Routes.AGENT_QA,
    permission: Permission.AGENT_INSIGHTS,
    tab: Tabs.AGENT_QA,
  },
  [Routes.AGENT_QA_INSIGHTS]: {
    navItem: Routes.AGENT_QA_INSIGHTS,
    permission: Permission.AGENT_INSIGHTS,
    tab: Tabs.AGENT_QA_INSIGHTS,
  },
  [Routes.AGENT_QA_SETUP]: {
    navItem: Routes.AGENT_QA_SETUP,
    permission: Permission.AGENT_INSIGHTS,
    tab: Tabs.AGENT_QA_SETUP,
  },
  [Routes.AGENT_INSIGHT_DETAIL]: {
    navItem: Routes.AGENT_QA,
    permission: Permission.AGENT_INSIGHTS,
    tab: Tabs.AGENT_QA,
  },
  [Routes.AI_QA]: {
    navItem: Routes.AI_QA,
    permission: Permission.AI_QA,
    tab: Tabs.AI_QA,
  },
  [Routes.LOG]: {
    navItem: Routes.LOG,
    permission: Permission.LOG,
    tab: Tabs.LOG,
  },
};
